import { render } from "./3PoolSharks.vue?vue&type=template&id=56c73d27"
import script from "./3PoolSharks.vue?vue&type=script&lang=js"
export * from "./3PoolSharks.vue?vue&type=script&lang=js"
script.render = render

export default script